// extracted by css-extract-rspack-plugin
export default {"title":"title-QOPT6T"};